<template>
  <div class="documentos-existentes">
    <v-card
      v-for="doc in documentos"
      :key="doc.id"
      class="mb-3 documento-card"
      :class="isSelected(doc) ? 'documento-card--selected' : ''"
      style="cursor: pointer"
      outlined
      elevation="2"
      @click="$emit('documento-seleccionado', doc)">
      <v-card-text class="pa-3">
        <v-row align="center" no-gutters>
          <!-- Indicador de selección -->
          <v-col cols="auto" class="pr-4">
            <v-icon :color="isSelected(doc) ? 'success' : '#cac9c9'" large>
              {{ isSelected(doc) ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
            </v-icon>
          </v-col>

          <!-- Información del documento -->
          <v-col>
            <div class="d-flex align-center flex-wrap">
              <div class="mr-6">
                <div class="text-caption grey--text">Tipo de Documento</div>
                <div class="font-weight-medium">{{ doc.tipoDocumentoPersona.nombre }}</div>
              </div>

              <div class="mr-6">
                <div class="text-caption grey--text">Persona</div>
                <div class="font-weight-medium">
                  {{ doc.persona.nombres }} {{ doc.persona.primerApellido }} {{ doc.persona.segundoApellido }}
                </div>
              </div>

              <div class="mr-6">
                <div class="text-caption grey--text">Formato</div>
                <div class="font-weight-medium text-uppercase">{{ doc.archivo.extencion }}</div>
              </div>

              <div class="mr-6">
                <div class="text-caption grey--text">Tamaño</div>
                <div class="font-weight-medium">{{ formatBytes(doc.archivo.size) }}</div>
              </div>

              <div>
                <div class="text-caption grey--text">Fecha</div>
                <div class="font-weight-medium">{{ formatDate(doc.archivo.create_at) }}</div>
              </div>
            </div>

            <!-- Datos adicionales (solo cuando está seleccionado) -->
            <div
              v-if="isSelected(doc) && doc.datos && doc.datos.length > 0"
              class="mt-3 pt-3"
              style="border-top: 1px solid #e0e0e0">
              <div class="text-caption grey--text mb-2">Datos Adicionales</div>

              <div class="d-flex align-center flex-wrap">
                <div v-for="dato in doc.datos" :key="dato.id" class="mr-6 mb-2">
                  <div class="text-caption grey--text">{{ dato.nombre }}</div>
                  <div class="font-weight-medium">{{ dato.valor }}</div>
                </div>
              </div>
            </div>
          </v-col>

          <!-- Icono según tipo de archivo -->
          <v-col cols="auto" class="pl-4">
            <v-icon large :color="getIconColor(doc.archivo.extencion)">
              {{ getFileIcon(doc.archivo.extencion) }}
            </v-icon>
          </v-col>

          <v-col cols="12" class="mt-3" v-if="isSelected(doc)">
            <DocumentoEstado :documento-persona="doc" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DocumentoEstado from './DocumentoEstado.vue';

export default {
  name: 'DocumentoExistente',
  components: {
    DocumentoEstado,
  },
  props: {
    documentos: {
      type: Array,
      default: () => [],
    },
    documentoSeleccionado: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getFileIcon(extension) {
      const icons = {
        pdf: 'mdi-file-pdf-box',
        png: 'mdi-file-image',
        jpg: 'mdi-file-image',
        jpeg: 'mdi-file-image',
        doc: 'mdi-file-word',
        docx: 'mdi-file-word',
        xls: 'mdi-file-excel',
        xlsx: 'mdi-file-excel',
      };
      return icons[extension?.toLowerCase()] || 'mdi-file-document';
    },
    getIconColor(extension) {
      const colors = {
        pdf: 'red',
        png: 'blue',
        jpg: 'blue',
        jpeg: 'blue',
        doc: 'blue darken-2',
        docx: 'blue darken-2',
        xls: 'green',
        xlsx: 'green',
      };
      return colors[extension?.toLowerCase()] || 'grey';
    },
    formatBytes(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-BO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    },
    isSelected(doc) {
      return this.documentoSeleccionado && doc.id === this.documentoSeleccionado.id;
    },
  },
};
</script>

<style scoped>
.documento-card {
  border-left: 4px solid #cac9c9;
  background-color: #ffffff;
  transition: all 0.3s ease;
}

.documento-card--selected {
  border-left-color: #388e3c !important;
}

.documento-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}
</style>